import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { PortalContext } from "../../../context/Provider";
import {
  multiTabDataMobilePaciente,
  multiTabsData,
} from "../../../../global/utils/multiTabData";
import { setOrigenMultitab } from "../../../context/Actions/multiTab/multiTab";
import Dropdown from "../../Genericos/Dropdown/Dropdown";
import { dropdownFamiliares } from "../ListaFamiliaresDropdown/ListaFamiliaresDropdown";
import { GlobalContext } from "../../../../global/context/Provider";
import routes from "_+_Portal/routes/listRoutes";
import ConsultaMedica from "_+_Portal/pages/ConsultaMedica/ConsultaMedica";
import Estudios from "_+_Portal/pages/Estudios/Estudios";
import Laboratorio from "_+_Portal/pages/Laboratorio/Laboratorio";
import "./MultitabMobile.css";

const MultitabMobile = ({ posicionMultitab, onChangeMultitabMobile, type }) => {
  const {
    multiTabState,
    multiTabDispatch,
    selectDropDownState,
    listaFamiliaresState,
  } = useContext(PortalContext);
  const { authState, configState } = useContext(GlobalContext);

  const [tabsData, setTabsData] = useState([...multiTabsData]);

  // Buscar el tab por ID, no por índice del array
  const getTabNombreById = (id) => {
    const tab = multiTabsData.find((t) => t.id === id);
    return tab ? tab.nombre : multiTabsData[0].nombre;
  };

  const [placeholderDropdownPagina, setPlaceholderDropdownPagina] = useState(
    getTabNombreById(posicionMultitab)
  );
  const placeholderDropdownPaciente = multiTabDataMobilePaciente[0].nombre;
  const widthWindow = window.innerWidth;
  const history = useHistory();

  // Actualizar el placeholder cuando cambia posicionMultitab
  useEffect(() => {
    setPlaceholderDropdownPagina(getTabNombreById(posicionMultitab));
  }, [posicionMultitab]);

  const onChangeMultitabMobilePagina = (e) => {
    if (e.id !== undefined) {
      if (configState.config.data.opcBuscadorTurnos) {
        let idComparador = 0;
        if (e.id === 0) {
          idComparador = 9;
        } else if (e.id === 1) {
          idComparador = 10;
        } else {
          idComparador = 11;
        }
        const index = routes.findIndex((objeto) => objeto.id === idComparador);
        if (index === -1) {
          routes.push(
            {
              id: 9,
              path: "/consultamedica",
              component: ConsultaMedica,
              title: "Buscador Consulta Médica",
              needsAuth: true,
            },
            {
              id: 10,
              path: "/estudios",
              component: Estudios,
              title: "Buscador Estudio",
              needsAuth: true,
            },
            {
              id: 11,
              path: "/laboratorio",
              component: Laboratorio,
              title: "Buscador Laboratorio",
              needsAuth: true,
            }
          );
        }
      }
      history.push(e.path);
      setPlaceholderDropdownPagina(e.nombre);
    }
    if (multiTabState.multiTab.paso !== 7) {
      setOrigenMultitab(null)(multiTabDispatch);
    }
    if (
      multiTabState.multiTab.paso === 3 &&
      configState.config.data.opcLaboratorio === false
    ) {
      setPlaceholderDropdownPagina(getTabNombreById(3)); // Recetas digitales
    }
  };

  useEffect(() => {
    if (configState.config.data !== null) {
      let dataTabs = tabsData;
      if (configState.config.data.opcLaboratorio === false) {
        dataTabs = dataTabs.filter((i) => i.id !== 2);
      }
      if (configState.config.data.opcRecetaDigital === false) {
        dataTabs = dataTabs.filter((i) => i.id !== 3);
      }
      if (configState.config.data.opcEstudios === false) {
        dataTabs = dataTabs.filter((i) => i.id !== 1);
      }
      if (configState.config.data.opcConsultaMedica === false) {
        dataTabs = dataTabs.filter((i) => i.id !== 0);
      }
      if (
        configState.config.data.opcBuscadorTurnos === false ||
        widthWindow <= 1024
      ) {
        dataTabs = dataTabs.filter((element) => element.id !== 5);
      }
      setTabsData(dataTabs);
    }
  }, [configState.config.data]);

  return (
    <React.Fragment>
      <div
        className={
          multiTabState.multiTab.paso === 3
            ? "ptur-multitabMobile-containerReceta"
            : "ptur-multitabMobile-container"
        }
      >
        <div className="ptur-multitabMobile-dropdown">
          <Dropdown
            valor={placeholderDropdownPagina}
            datos={tabsData}
            campoCodigo="nombre"
            descripcion="nombre"
            onChange={onChangeMultitabMobilePagina}
            notSearch={true}
            placeholder={placeholderDropdownPagina}
            heightLista={"auto"}
          />
        </div>
        {/* Dejo este para omitir el segundo dropdown hasta que se aplique la funcionalidad en receta digital*/}
        {multiTabState.multiTab.paso === 3 ? (
          ""
        ) : (
          <div className="ptur-multitabMobile-dropdown">
            <Dropdown
              valor={
                selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
                  ? selectDropDownState.selectDropDown.selectGlobal
                      .pacienteElegido.id
                  : authState?.auth?.data?.paciente?.codigo
              }
              datos={dropdownFamiliares(
                listaFamiliaresState,
                authState,
                "ManejoTurnos"
              )}
              campoCodigo="id"
              descripcion="nombre"
              onChange={onChangeMultitabMobile}
              placeholder={placeholderDropdownPaciente}
              notSearch={true}
              heightLista={"auto"}
            />
          </div>
        )}
      </div>
      <div className="ptur-multitabMobile-componente-container"></div>
    </React.Fragment>
  );
};

export default MultitabMobile;
